import React, { useState, useMemo } from 'react'
import styled from 'styled-components'
import { checkIsRequired } from './helper/text'
import { Require } from './RequireInfo'
import { Input } from '@intelie/ui'
import { Tooltip } from '@intelie/ui'
import { LabelWithTooltip } from './LabelWithTooltip'

export default function Text({
    label,
    onChange,
    value,
    infoText = '',
    disabled = false,
    isRequire = true,
    onChangeMessageError,
    tooltipMessenger
}: {
    value: string
    label: string
    onChange: (rule: string) => void
    onChangeMessageError?: (value: string) => string | void
    disabled?: boolean
    isRequire?: boolean
    infoText?: string
    tooltipMessenger?: string
}) {
    const [info, setInfoState] = useState<{
        state: 'default' | 'error' | 'valid' | 'warning'
        msg: string
    }>({
        msg: infoText,
        state: 'default'
    })
    return (
        <Container>
            <Input className='input'
                inputState={info.state}
                label={
                    <div>
                        <LabelWithTooltip label={label} tooltipMessenger={tooltipMessenger} />
                        <Require show={info.state === 'error' ? true : checkIsRequired(value, isRequire, disabled)} />
                   </div>
                }
                disabled={disabled}
                type={'text'}
                onChange={({ target }) => {
                    const text = String(target?.value)
                    const messageError =
                        typeof onChangeMessageError === 'function' ? onChangeMessageError(text) : undefined

                    if (!!messageError) setInfoState(() => ({ msg: messageError, state: 'error' }))
                    else if (info.state !== 'default') {
                        setInfoState({ msg: infoText, state: 'default' })
                    }
                    onChange(text)
                }}
                value={value}
                infoText={info.msg}
            />
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    padding: 8px 24px;

    .input{
        border:0;
    }

`

export { Text }
